<template>
	<div>
		<BaseLink
			v-if="isUser"
			data-test="ira-landing-cta-link"
			:link="existingInvestorLink"
			classes="button button-primary"
		/>
		<LeadCaptureComponent v-else :class="props.leadCaptureClasses" :form-config="leadCaptureFormConfig" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import LeadCaptureComponent from '@components/lead-capture/lead-capture-form.vue';
import { LeadCaptureFormConfig } from 'types/layout/lead';
import { Link } from 'types/layout';
import { ThirdPartyAuthTheme } from 'types/third-party-auth';
import { useUserStore } from '@stores/user';

interface Props {
	leadCaptureClasses?: string;
	shouldBeCentered?: boolean;
	thirdPartyAuthDisclaimerClass?: string;
	thirdPartyAuthTheme?: ThirdPartyAuthTheme;
}
const props = withDefaults(defineProps<Props>(), {
	shouldBeCentered: true,
	thirdPartyAuthTheme: undefined,
	thirdPartyAuthDisclaimerClass: undefined,
	leadCaptureClasses: ''
});

const userStore = useUserStore();

const existingInvestorLink: Link = {
	text: 'Get started',
	router: 'ira-start'
};

const isUser = !!userStore.user;

const leadCaptureFormConfig = computed((): LeadCaptureFormConfig => {
	return {
		centerButton: props.shouldBeCentered,
		signupFlowType: 'STANDARD',
		thirdPartyAuthTheme: props.thirdPartyAuthTheme,
		thirdPartyAuthDisclaimerClass: props.thirdPartyAuthDisclaimerClass
	};
});
</script>
